<template>
  <div>
    <HeroSection
      :nav-breadcrumbs="[
        {
          href: '/training',
          title: 'Training'
        },
        {
          href: '/training/courses',
          title: 'Courses'
        }
      ]"
      :value="coursesPage.hero_section"
    >
      <template v-if="coursesPage.hero_section.cta" #cta>
        <HeroCta :value="coursesPage.hero_section.cta" />
      </template>
    </HeroSection>

    <TrainingDifferentiatorsSection
      :scroll-to-section="scrollToSection"
      :value="coursesPage.training_differentiators_section"
      class="mb-16 hero-section hero-below-offset"
    />

    <LogoBarSection
      :items="logos"
      :value="coursesPage.logo_bar_section"
      class="mb-16"
    />

    <ProductsOverviewSection
      class="mb-8"
      :items="courses"
      :learn-href="item => `/training/courses/${slugify(item)}`"
      :schedule-href="
        item => `/training/schedule?what=${item.code.toLowerCase()}`
      "
      :value="coursesPage.products_overview_section"
    />

    <v-container
      :ref="
        el => {
          sectionRefs.register = el
        }
      "
    />

    <v-lazy>
      <OccasionsSection
        :banner="banner"
        :filters-value="{ occasionType: 'C' }"
        :value="coursesPage.classes_section"
        :what-menu="whatMenu"
        class="mb-16"
      />
    </v-lazy>

    <ReviewsSection :items="reviews" class="mb-16" />

    <ServicesSection :value="coursesPage.services_section" class="mb-16" />

    <DividerSection class="mb-16" />

    <ContactCtaSection :value="coursesPage.contact_cta_section" class="mb-16" />
  </div>
</template>

<script setup lang="ts">
import { reactive } from 'vue'
import { useProvideDeliveryMethodsStore } from '#root/lib/useDeliveryMethodsStore'
import { useProvideTrainerPersonsStore } from '#root/lib/useTrainerPersonsStore'
import { scrollToRefKey, slugify } from '#root/lib/utils'

const sectionRefs = reactive({})

const props = defineProps({
  banner: {
    default: undefined,
    type: Object
  },
  courses: {
    required: true,
    type: Array
  },
  coursesPage: {
    required: true,
    type: Object
  },
  deliveryMethods: {
    required: true,
    type: Array
  },
  logos: {
    required: true,
    type: Array
  },
  reviews: {
    required: true,
    type: Array
  },
  trainers: {
    required: true,
    type: Array
  },
  whatMenu: {
    required: true,
    type: Object
  }
})

useProvideDeliveryMethodsStore(props.deliveryMethods)
useProvideTrainerPersonsStore(props.trainers)

function scrollToSection({ key }) {
  scrollToRefKey(sectionRefs, key)
}
</script>
